import { render, staticRenderFns } from "./childrenTableModules.vue?vue&type=template&id=725e839c&scoped=true&"
import script from "./childrenTableModules.vue?vue&type=script&lang=js&"
export * from "./childrenTableModules.vue?vue&type=script&lang=js&"
import style0 from "./childrenTableModules.vue?vue&type=style&index=0&id=725e839c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725e839c",
  null
  
)

export default component.exports